import React, { useState, useEffect, useRef } from "react";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { SketchPicker } from "react-color";
import { API_URL } from "../../../../constants/index";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { toast } from "react-toastify";
import { FaSpinner } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";

function AttendanceStatus() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Attendance Status"));
  }, []);

  const [attendanceStatus, setAttendanceStatus] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [errors, setErrors] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [submitted, setSubmit] = useState(false);
  const [Color, setColor] = useState("#ff0000");
  const [displayColorPicker, setDisplayColorPicker] = useState(false);
  const [apiStatus, SetApiStatus] = useState(undefined);
  const [formData, setFormData] = useState({
    Name: "",
    Code: "",
    Value: "",
    Description: "",
    IsInactive: 0,
    Color: "#ff0000",
  });
  const handleChangeComplete = (Color) => {
    setColor(Color.hex);
    setFormData({ ...formData, Color: Color.hex });
  };
  const columns = {
    Code: { text: "Code", visible: "true" },
    NameWithColor: { text: "Name", visible: "true" },
    Description: { text: "Description", visible: "true" },
    Value: { text: "Payable Days", align: "center", visible: "true" },
    IsInactive: { text: "Active", align: "center", visible: "true" },
  };

  const handleInputClick = () => {
    setDisplayColorPicker(!displayColorPicker);
  };

  const handleClose = () => {
    setDisplayColorPicker(false);
  };
  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? (checked ? 1 : 0) : value,
    });

    // Clear the error for this field if it exists
    if (errors[name]) {
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const resetFormState = () => {
    setFormData({
      Name: "",
      Code: "",
      Value: "",
      Description: "",
    });
    setIsEditMode(false); // Reset edit mode state
  };
  const validateForm = () => {
    const newErrors = {};

    if (!formData.Code) newErrors.Code = "Code is required";
    if (!formData.Name) newErrors.Name = "Name is required";
    if (!formData.Value) newErrors.Value = "Payable Days is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleAddNewAttendance = () => {
    setShowModal(true);
  };

  const handleEditModalClose = () => {
    setShowModal(false);
    resetFormState();
    setErrors({});
    setSubmit(false);
    setColor("#ff0000");
  };

  const fetchAttendanceDetails = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}attendanceStatus`);
      SetApiStatus(response?.status);
      if (response.status === 200) {
        const cleanedData = response?.data?.header;
        const updatedData = cleanedData.map((item) => ({
          ...item,
          NameWithColor: <span style={{ color: item.Color }}>{item.Name}</span>,
        }));
        setAttendanceStatus(updatedData);
      } else {
        console.error(
          "Failed to fetch skills. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };
  useEffect(() => {
    fetchAttendanceDetails();
  }, []);

  const handleEdit = async (id) => {
    setShowModal(true);
    setIsEditMode(true);
    try {
      const response = await GetServiceCaller(
        `${API_URL}attendanceStatus/${id.ID}`
      );
      if (response.status === 200) {
        const attendanceData = response?.data?.attendanceStatus;
        if (attendanceData) {
          const { Name, Code, Value, Description, IsInactive, Color } =
            attendanceData;
          // Update both form data and Color state
          setFormData({
            id: id.ID,
            Name: Name || "",
            Code: Code || "",
            Value: Value || "",
            Color: Color || "#ff0000",
            Description: Description || "",
            IsInactive: IsInactive === 1 ? 1 : 0,
          });
          setColor(Color || "#ff0000"); // Also update the Color state
        } else {
          console.error("Attendance Data not found with ID:", id);
        }
      } else {
        console.error(
          "Failed to fetch Attendance details. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Attendance details:", error);
    }
  };
  const [isSubmitting, setSubmitting] = useState(false);
  const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (isSubmitting) return;

    if (validateForm()) {
      setSubmitting(true);
      const method = isEditMode ? "put" : "post";
      const apiUrl = isEditMode
        ? `${API_URL}attendanceStatus/${formData.id}`
        : `${API_URL}attendanceStatus`;

      try {
        const response = await PostServiceCaller(apiUrl, formData, method);
        if (response && (response.status === "success" || response.status === 200 || response.statusCode === 200)) {
          const successMessage =
            method === "post" ? "Form submitted successfully!" : "Form updated successfully!";
          toast.success(successMessage);
          resetFormState();
          fetchAttendanceDetails();
          setIsEditMode(false);
          setShowModal(false);
        } else {
          // Show only the API's error message if it exists
          const errorMessage = response?.message || response?.data?.message;
          console.error("API error:", errorMessage);
          toast.error(errorMessage);
        }
      } catch (error) {
        console.error("Submission error:", error); // Debug log
        // Handle network errors separately
        const errorMessage =
          error.response?.data?.message ||
          error.message ||
          "An error occurred while processing your request";
        toast.error(errorMessage);
      } finally {
        console.log("Setting submitting to false"); // Debug log
        setSubmitting(false);
      }
    }
  };
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={attendanceStatus}
              columns={columns}
              itemsPerPage={8}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              showIcon1={true}
              isApiStatus={apiStatus}
              isSorting={true}
              isRequiredStatus={true}
              isAddNewBtnRequired={true}
              handleIcon1={handleEdit}
              handleAddNew={handleAddNewAttendance}
              isActionRequired={true}
              add
              more
              function
              icons={{
                Icon1: <i class="bi bi-pencil-square"></i>,
              }}
            />
          </div>
        </div>
        {showModal && (
          <div
            className="modal"
            tabIndex="-1"
            role="dialog"
            style={{
              display: "block",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            }}
          >
            <div
              className="modal-dialog modal-dialog-centered modal-md"
              role="document"
            >
              <div className="modal-content">
                <div
                  className="modal-header d-flex justify-content-between"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderBottom: "1px solid #f0f0f0",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "8px 8px 0 0",
                  }}
                >
                  <h3
                    style={{
                      fontSize: "16px",
                      fontWeight: "600",

                      color: "#27568B",

                      margin: "0",
                    }}
                  >
                    {isEditMode
                      ? "Edit Attendance Details"
                      : "Add Attendance Details"}
                  </h3>
                  <button
                    className=""
                    style={{
                      background: "none",

                      border: "none",

                      cursor: "pointer",

                      fontSize: "18px",

                      color: "#000",

                      padding: "4px",

                      borderRadius: "4px",

                      transition: "all 0.2s",

                      lineHeight: "1",
                    }}
                    onClick={handleEditModalClose}
                  >
                    <i className="bi bi-x-lg"></i>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="box-body">
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-md-6 col-12">
                          <div className="mb-3">
                            <label htmlFor="Code" className="form-label">
                              Code<span className="required">*</span>
                            </label>
                            <input
                              type="text"
                              className={`form-control ${
                                errors.Code ? "is-invalid" : ""
                              }`}
                              id="Code"
                              aria-describedby="Code"
                              name="Code"
                              placeholder="Code"
                              value={formData.Code}
                              onChange={handleInputChange}
                            />
                            {errors.Code && (
                              <div className="invalid-feedback">
                                {errors.Code}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6 col-12">
                          <div className="mb-3">
                            <label htmlFor="Name" className="form-label">
                              Name<span className="required">*</span>
                            </label>
                            <input
                              type="text"
                              className={`form-control ${
                                errors.Name ? "is-invalid" : ""
                              }`}
                              id="Name"
                              aria-describedby="Name"
                              name="Name"
                              placeholder="Name"
                              value={formData.Name}
                              onChange={handleInputChange}
                            />
                            {errors.Name && (
                              <div className="invalid-feedback">
                                {errors.Name}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6 col-12">
                          <div className="mb-3">
                            <label htmlFor="payabledays" className="form-label">
                              Payable Days<span className="required">*</span>
                            </label>
                            <input
                              type="text"
                              className={`form-control text-end ${
                                errors.Value ? "is-invalid" : ""
                              }`}
                              id="payabledays"
                              aria-describedby="payabledays"
                              name="Value"
                              placeholder="Payable Days"
                              value={formData.Value}
                              onChange={handleInputChange}
                            />
                            {errors.Value && (
                              <div className="invalid-feedback">
                                {errors.Value}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6 col-12">
                          <div className="mb-3">
                            <label htmlFor="colorInput" className="form-label">
                              Color<span className="required">*</span>
                            </label>
                            <input
                              type="text"
                              id="colorInput"
                              value={Color}
                              onClick={handleInputClick}
                              readOnly
                              className="form-control"
                              style={{
                                backgroundColor: Color,
                                cursor: "pointer",
                              }}
                            />
                            {displayColorPicker && (
                              <div
                                style={{
                                  position: "absolute",
                                  zIndex: "1050",
                                }}
                              >
                                <div
                                  style={{
                                    position: "fixed",
                                    top: "0px",
                                    right: "0px",
                                    bottom: "0px",
                                    left: "0px",
                                  }}
                                  onClick={handleClose}
                                />
                                <SketchPicker
                                  color={Color}
                                  onChangeComplete={handleChangeComplete}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="mb-3">
                            <label htmlFor="Description" className="form-label">
                              Description
                            </label>
                            <textarea
                              className="form-control"
                              id="Description"
                              aria-describedby="Description"
                              name="Description"
                              placeholder="Description"
                              value={formData.Description}
                              onChange={handleInputChange}
                              rows="3"
                            />
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="row">
                            <div className="col-sm-3">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  name="IsInactive"
                                  id="flexSwitchCheckChecked"
                                  checked={formData.IsInactive === 1}
                                  onChange={handleInputChange}
                                />
                                <label
                                  htmlFor="flexSwitchCheckChecked"
                                  className="form-check-label"
                                >
                                  Active
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="text-end mt-2 ">
                        <button
                          className="cancel-btn me-2"
                          onClick={() => handleEditModalClose()}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="custom-btn"
                          disabled={isSubmitting}
                        >
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default AttendanceStatus;
